import { connect } from 'react-redux'
import { ICountTripStatusFilter, IStoreState, ITripFilters } from '../../types'
import TripsDashboardFilter from '../../components/trips/TripsDashboardFilter'
import * as actions from '../../state/actions/trips'

export function mapStateToProps(state: IStoreState) {
  return {
    currentOrganizationId: state.organizations.currentOrgId,
    tripFilters: state.trips.filters,
    tripStatusCount: state.trips.tripStatusCount
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    updateTripFilters: (filters: ITripFilters) => {
      return dispatch(actions.actionCreators.updateTripFilters(filters))
    },
    getTripStatusesCount: (params: ICountTripStatusFilter) => {
      return dispatch(actions.getTripStatusesCount(params))
    }
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TripsDashboardFilter)



// WEBPACK FOOTER //
// ./src/containers/trips/TripsDashboardFilter.ts